import dynamic from 'next/dynamic';

import type { PlpPreviewSectionProps } from 'src/components/sections/PlpPreviewSection/PlpPreviewSection';
import type { SectionRenderer } from 'src/types/Section';
import type { Transformer } from 'src/types/Transformer';
import type { PlpPreviewContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<PlpPreviewSectionProps> = dynamic<PlpPreviewSectionProps>(
  () =>
    import('src/components/sections/PlpPreviewSection/PlpPreviewSection').then(
      (mod) => mod.PlpPreviewSection,
    ),
);

export const transformer: Transformer<PlpPreviewContentSection, PlpPreviewSectionProps> = (
  { _metadata, reference },
  { pageConfig, pageMetadata, positionMetadata },
) => {
  const referencedPlp = reference?.[0];

  if (!referencedPlp?.url || !referencedPlp?.heading) {
    // Throwing skips the block (logged; surfaced as a preview-mode warning for editors).
    throw new Error(
      `Missing referenced Taxonomy PLP fields (uid: ${_metadata.uid}). Check that the referenced PLP is published.`,
    );
  }

  return {
    uid: _metadata.uid,
    props: {
      currency: pageMetadata.currency,
      heading: referencedPlp.heading,
      pageType: pageConfig.pageType,
      plpUrl: referencedPlp.url,
      trackingPosition: positionMetadata.position,
      trackingTitle: referencedPlp.heading,
    },
  };
};
